import React from "react";

export default function DefaultRow({ args }) {
  return (
    <>
      {args.map((row, index) => {
        return (
          <React.Fragment key={`unique-container-${index}`}>
            <tr key={`unique-separator-${index}`} className="h-2"></tr>
            <tr key={`unique-tr-${index}`} className="rounded">
              <td
                key={`unique-td-indice-${index}`}
                className="rounded-s-lg !p-5 content-center"
              >
                {index + 1}
              </td>
              {row.map((item, index) => {
                return (
                  <td
                    key={`unique-th-index-${index}`}
                    className={
                      (index === row.length - 1 ? "rounded-r-lg" : "") +
                      " !p-5 content-center text-[14px]"
                    }
                  >
                    {typeof item === "boolean" ? (item ? "Sim" : "Não") : item}
                  </td>
                );
              })}
            </tr>
          </React.Fragment>
        );
      })}
    </>
  );
}
